<template>
  <section class="assessmentSection">
    <ProgressBar :value="15" />
    <div class="pageContent mb-12">
      <div class="pageTitle">
        We analyzed your home for <br> environmental threats.
      </div>

      <div class="text-bold">Regular smoke detectors just don’t cut it.</div>
      <div
        class="mb-4"
      >Store bought detectors do not work 75% of the time and do not call the authorities. See how our smoke communicators compare.</div>

      <div class="text-bold">Carbon monoxide risk is present for all homes.</div>
      <div
        class="mb-4"
      >Furnaces, faulty appliances, and heating elements all pose a risk for carbon monoxide poisoning.</div>
    </div>

    <div class="bg-blue-lightest equipment-section">
      <div class="pageContent">
        <div class="pageTitle productSectionTitle">
          Upgrade my system with
          <br /><span class="text-blue">Environmental Protection</span>
        </div>
        
        <EquipmentInfoWithQuantity :equipment="equipment" @change="handleEquipmentChange" />
        
      </div>
    </div>

    <div class="continue-section">
      <continue-button :to="continueTo" />
      <ModuleNeedHelp />
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import formatCurrency from "../Libraries/formatCurrency";
import ProgressBar from "../components/ProgressBar.vue";
import EquipmentInfoWithQuantity from '../components/EquipmentInfoWithQuantity.vue';
import ModuleNeedHelp from "../components/ModuleNeedHelp.vue";

export default {
  components: {
    ProgressBar,
    EquipmentInfoWithQuantity,
    ModuleNeedHelp,
  },
  data: () => ({
    descriptionVisibilities: [false, false],
    equipment: []
  }),
  methods: {
    setEquipment() {
      let equipment = [
        this.$store.getters.equipmentByName("Smoke Communicator"),
        this.$store.getters.equipmentByName("Flood Sensor")
      ];

      equipment = equipment.map(e => {
        e.quantity = this.$store.state.lead.automationQuantities[e.lead_key];
        e.subtotal = this.calculateSubtotal(e);
        return e;
      });

      this.equipment = equipment;
    },

    calculateSubtotal(equipment) {
      let quantity = equipment.quantity;
      let price = equipment.price;
      let total = quantity * price;
      let formatted = formatCurrency(total).replace(".00", "");

      return formatted;
    },

    handleEquipmentChange(newEquipment) {
      this.equipment = newEquipment
    }
  },
  mounted() {
    this.$store.watch(state => {
      if (state.equipment.length && !this.equipment.length) {
        this.setEquipment();
      }
    });
  }
};
</script>

<style src="./AssessmentModule.css" scoped></style>
<style src="../../sass/components/continue-section.css" scoped></style>
